import { Label } from "reactstrap";
import { useState } from "react";

// Make SelectInput generic for any form data type

type StringKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : never
}[keyof T];

interface SelectInputProps<T> {
  formData: T;
  setFormData: (data: T) => void;
  label: string;
  id: StringKeys<T>;
  options: string[];
}

function SelectInput<T>({ formData, setFormData, label, id, options }: SelectInputProps<T>) {
  const selectedValue = formData[id] as string;

  return (
    <div className="mb-3">
      <Label htmlFor={String(id)} className="form-label mb-0">
        {label}
      </Label>
      <select
        className="form-select form-select-sm w-full"
        id={String(id)}
        aria-label={label}
        value={selectedValue || ''}
        onChange={e => setFormData({ ...formData, [id]: e.target.value })}
      >
        <option value="" disabled>Select...</option>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectInput; 